import script from "./StoreNeue.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreNeue.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import CopyableLink from "@/components/neue/CopyableLink.vue";
import PageFooter from "@/components/PageFooter.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { CopyableLink, PageFooter, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { CopyableLink, PageFooter, SecondaryNav, SecondaryTop }, script.__o.components);}